<template>
    <div class="right-side-navbar d-flex align-items-center justify-content-end">

                        <div class="right-side-trigger" id="rightSideTrigger">
                            <i class="fas fa-bars"></i>
                        </div>


                        <ul class="right-side-content d-flex align-items-center">

                            <li class="nav-item dropdown dropdown-animate">
                            <a class="nav-link" :class="conteo > 0 ? 'nav-link-icon-bjar' : 'nav-link-icon'" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                <i class="fa fa-bell faa-ring" :class="conteo > 0 ? 'animated' : ''">{{conteo}}</i>
                            </a>
                            <div class="dropdown-menu dropdown-menu-right dropdown-menu-lg dropdown-menu-arrow p-0 scrollNotificacion">
                                <div class="py-3 px-3">
                                    <h5 class="heading h6 mb-0">Notificaciones</h5>
                                </div>

                                <div v-for="(n, index) in arrayNotificacion" :key="index" class="list-group list-group-flush" id="notificationsBox" >

                                    <div class="list-group-item list-group-item-action" @click="seguimientoDetalle(n.id)">

                                        <div class="d-flex align-items-center" data-toggle="tooltip" data-placement="right" data-title="2 hrs ago">
                                            <!---<div class="heading-avatar bg-primary text-white rounded-circle" v-text="n.iniciales">AM</div>-->
                                            <div class="chat-image chat-active">

                                                <template v-if="!n.file">
                                                    <div class="chat-image">
                                                        <img  class="chat-box-img" src="img/noimageuser.png" :alt="n.asesor">
                                                    </div>
                                                </template>
                                                <template v-else>
                                                    <div  class="chat-image">
                                                        <img  class="chat-box-img" v-bind:src="'storage/users/'+n.file" :alt="n.asesor">
                                                    </div>
                                                </template>
                                            </div>

                                            <div class="flex-fill ml-3">
                                                <p> <b>Asesor:</b> <span v-text="n.asesor"></span></p>
                                                <div class="font-14 mb-0">{{n.cliente}}

                                                    <small class="float-right text-danger" v-if="n.dias_restantes > 0" v-text="' venció hace ' +n.dias_restantes+ ' días'"></small>
                                                    <small class="float-right text-warning" v-else v-text="' Hoy vence el plazo'"></small>

                                                </div>
                                                <p class="font-12 mb-0" v-text="n.comentario"></p>
                                            </div>
                                        </div>
                                    </div>




                                </div>
                            </div>
                        </li>


                            <li class="nav-item dropdown">
                                <button type="button" class="btn dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">

                                            <template v-if="!usuario.file">
                                                <img src="img/noimageuser.png" class="chat-img-2" :alt="usuario.fullname">
                                           </template>
                                           <template v-else>
                                                <img class="chat-img-2"  v-bind:src="'storage/users/'+usuario.file" :alt="usuario.fullname">
                                           </template>
                                    </button>
                                <div class="dropdown-menu dropdown-menu-right">

                                    <div class="user-profile-area">
                                        <div class="user-profile-heading text-center p-3 mb-20">

                                           <template v-if="!usuario.file">
                                               <div class="profile-img">
                                                   <img src="img/noimageuser.png" :alt="usuario.fullname">
                                               </div>

                                           </template>
                                           <template v-else>
                                               <div  class="profile-img">
                                                    <img v-bind:src="'storage/users/'+usuario.file" :alt="usuario.fullname">
                                                </div>
                                           </template>


                                            <div class="profile-text mt-20">
                                                <h6>{{usuario.fullname}}</h6>
                                                <span>{{usuario.rol[0].name}}</span>
                                            </div>
                                        </div>

                                        <a href="#" class="dropdown-item" @click.prevent="logout">
                                            <i class="ti-unlink profile-icon" aria-hidden="true"></i> Cerrar Sesión
                                        </a>
                                    </div>
                                </div>
                            </li>
                        </ul>

        <div class="modal fade " :class="{ show: modalShowSeguimiento }" :style=" modalShowSeguimiento ? mostrarModal : 'ocultarModal'" >
            <div class="modal-dialog modal-lg modal-dialog-scrollable">
                <div class="modal-content">
                        <div class="modal-header bg-info ">
                            <h5 class="modal-title mt-0 font-16 color-text-p" id="myLargeModalLabel" >Seguimiento Cotización</h5>
                            <button type="button" @click="cerrarModalSeguimiento" class="close color-text-p .close2" data-dismiss="modal" aria-hidden="true">×</button>
                        </div>
                        <div class="modal-body">
                            <h6 v-text="cotizacion.cliente + ' - ' + cotizacion.vehiculo + ' - ' + cotizacion.vehiculo_anio"></h6>
                            <ul class="nav nav-tabs" id="pills-tab" role="tablist">

                                <li class="nav-item" role="presentation">
                                    <a class="nav-link active" id="detalle_navbar-tab" data-toggle="pill" href="#detalle_navbar" role="tab" aria-controls="detalle" aria-selected="true"><i class="fas fa-file-contract"></i> Datos del Cliente</a>
                                </li>

                                <li class="nav-item" role="presentation">
                                    <a class="nav-link" id="tab-seguimiento_navbar-tab" data-toggle="pill" href="#tab-seguimiento_navbar" role="tab" aria-controls="tab-seguimiento_navbar" aria-selected="false"><i class="fas fa-file-medical-alt"></i> Seguimiento</a>
                                </li>

                                <li class="nav-item" role="presentation">
                                    <a class="nav-link" id="tab-agregar_navbar-tab" data-toggle="pill" href="#tab-agregar_navbar" role="tab" aria-controls="tab-agregar_navbar" aria-selected="true"><i class="fas fa-file-contract"></i> Agregar</a>
                                </li>

                            </ul>
                            <div class="tab-content" id="pills-tabContent">

                                <div class="tab-pane fade  show active" id="detalle_navbar" role="tabpanel" aria-labelledby="detalle_navbar-tab">
                                    <div class="row">
                                    <div class="col-md-12 col-sm-12 col-lg-12">
                                        <table class="table">
                                            <tbody>
                                                <tr>
                                                    <th scope="row"><b>Nombre y Apellido</b></th>
                                                    <td v-text="cotizacion.cliente"></td>
                                                </tr>
                                                <tr>
                                                    <th scope="row"><b>Número de cédula o RUC</b></th>
                                                    <td v-text="cotizacion.cliente_num_doc"></td>
                                                </tr>
                                                <tr>
                                                    <th scope="row"><b>Números de teléfono</b></th>
                                                    <td>
                                                        <a  class="btn btn-rounded btn-outline-success mb-2 mr-2" v-for="(tel, index_tel) in cotizacion.telefonos" :key="index_tel" :href="tel.wsp" target="_blank">
                                                            <i class="fab fa-whatsapp"></i>
                                                            {{ tel.telefono }}
                                                        </a>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th scope="row"><b>Email</b></th>
                                                    <td v-text="cotizacion.cliente_email"></td>
                                                </tr>
                                                <tr>
                                                    <th scope="row"><b>Marca de vehículo</b></th>
                                                    <td v-text="cotizacion.marca_vehiculo"></td>
                                                </tr>
                                                <tr>
                                                    <th scope="row"><b>Modelo de vehículo</b></th>
                                                    <td v-text="cotizacion.modelo_vehiculo"></td>
                                                </tr>
                                                <tr>
                                                    <th scope="row"><b>Año de vehículo </b></th>
                                                    <td v-text="cotizacion.vehiculo_anio"></td>
                                                </tr>
                                                <tr>
                                                    <th scope="row"><b>Valor asegurado de vehículo</b></th>
                                                    <td v-text="cotizacion.suma_asegurada"></td>
                                                </tr>
                                                <tr>
                                                    <th scope="row"><b>Prima neta de vehículo </b></th>
                                                    <td v-text="cotizacion.prima_neta"></td>
                                                </tr>
                                                <tr>
                                                    <th scope="row"><b>Tasa de seguro </b></th>
                                                    <td v-text="cotizacion.tasa_seguro"></td>
                                                </tr>
                                                <tr>
                                                    <th scope="row"><b>Seguro Cotizando  </b></th>
                                                    <td v-text="cotizacion.empresa"></td>
                                                </tr>
                                                <tr>
                                                    <th scope="row"><b>GPS</b></th>
                                                    <td v-text="cotizacion.dispositivo_rastreo"></td>
                                                </tr>
                                            </tbody>
                                            </table>
                                    </div>
                                    </div>
                                </div>

                                <div class="tab-pane fade" id="tab-seguimiento_navbar" role="tabpanel" aria-labelledby="tab-seguimiento_navbar-tab">
                                    <div class="kt-portlet kt-portlet--tabs kt-portlet--height-fluid scrollTableSeguimiento">
                                        <div class="kt-scroll ps ps--active-y" data-scroll="true" data-mobile-height="350">
                                                                    <!--Begin::Timeline -->
                                            <div v-for="(s, index) in arraySeguimiento" :key="index" class="kt-timeline">
                                                <!--Begin::Item -->
                                                <div :class="'kt-timeline__item kt-timeline__item--'+[s.estado=='VOLVER A LLAMAR' ? 'warning' : s.estado=='NUMERO INCORRECTO' ? 'danger' : s.estado=='NO DESEA' ? 'danger' : s.estado=='AGENDAR' ? 'success' :'brand']">

                                                    <div class="kt-timeline__item-section">
                                                        <div class="kt-timeline__item-section-border">
                                                            <div class="kt-timeline__item-section-icon">
                                                                <i v-if="s.estado=='GESTION TELEFONICA'" class="fas fa-phone-square-alt text-success font-weight-bold"></i>
                                                                <i v-else-if="s.estado=='VOLVER A LLAMAR'" class="fas fa-phone-volume text-warning font-weight-bold"></i>
                                                                <i v-else-if="s.estado=='NUMERO INCORRECTO'" class="fas fa-phone-slash text-danger font-weight-bold"></i>
                                                                <i v-else-if="s.estado=='NO DESEA'" class="fas fa-ban text-danger font-weight-bold"></i>
                                                                <i v-else-if="s.estado=='AGENDAR'" class="far fa-address-book text-primary font-weight-bold"></i>
                                                                <i v-else-if="s.estado=='CITA'" class="far fa-calendar-alt text-success font-weight-bold"></i>
                                                                <i v-else-if="s.estado=='SEGUIMIENTO DE CIERRE'" class="fas fa-file-signature text-success font-weight-bold"></i>
                                                                <i v-else-if="s.estado=='RECOLECION DE DOCUMENTOS'" class="fas fa-paste text-success font-weight-bold"></i>
                                                                <i v-else-if="s.estado=='GESTION DE INSPECCION'" class="fas fa-search text-success font-weight-bold"></i>
                                                                <i v-else-if="s.estado=='GESTION DE EMISION'" class="fab fa-searchengin text-success font-weight-bold"></i>
                                                                <i v-else-if="s.estado=='GESTION DE LIBERACION'" class="fas fa-bullhorn text-success font-weight-bold"></i>
                                                                <i v-else class="fas fa-check-double text-success font-weight-bold"></i>
                                                            </div>
                                                        </div>
                                                        <span class="kt-timeline__item-datetime" v-text="formatoFechaSeguimiento(s.created_at) + ' - ' +s.estado"></span>
                                                    </div>

                                                    <a class="kt-timeline__item-text"> <b>Vigencia inicio: </b> <spa v-text="formatoFechaSeguimiento(s.vigencia_inicio, 'D [de] MMMM [del]  YYYY')"></spa> </a>
                                                    <a class="kt-timeline__item-text"> <b>Vigencia fin: </b> <spa v-text="formatoFechaSeguimiento(s.vigencia_fin, 'D [de] MMMM [del]  YYYY')"></spa> </a>
                                                    <br>
                                                    <a class="kt-timeline__item-text" v-text="s.comentario"></a>
                                                    <div class="kt-timeline__item-info"  v-if="s.file!=null && s.file!=''">
                                                        <a :href="'storage/files/'+s.file" :download="s.file"  class="btn btn-link"><i class="fas fa-file-download"></i> {{s.file}}</a>

                                                    </div>
                                                </div>
                                                <!--End::Item -->

                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="tab-pane fade" id="tab-agregar_navbar" role="tabpanel" aria-labelledby="tab-agregar_navbar-tab">
                                    <div class="row">
                                        <div class="col-md-4 col-sm-4 col-lg-4">
                                                <div class="form-group">
                                                    <label for="estado">Estado</label>
                                                    <select class="custom-select" v-model="seguimiento.estado">
                                                        <option style="color:red;" value="0">Selecione un estado</option>
                                                        <option style="color:red;" value="GESTION TELEFONICA">Gestion Telefonica</option>
                                                        <option style="color:red;" value="VOLVER A LLAMAR">Volver A Llamar</option>
                                                        <option style="color:red;" value="NUMERO INCORRECTO">Numero Incorrecto</option>
                                                        <option style="color:red;" value="NO DESEA">No Desea</option>
                                                        <option style="color:red;" value="AGENDAR">Agendar</option>
                                                        <option style="color:red;" value="CITA">Cita</option>
                                                        <option style="color:red;" value="SEGUIMIENTO DE CIERRE">Seguimiento De Cierre</option>
                                                        <option value="RECOLECION DE DOCUMENTOS">Recolecion De Documentos</option>
                                                        <option value="GESTION DE INSPECCION">Gestion De Inspeccion</option>
                                                        <option value="GESTION DE EMISION">Gestion De Emision</option>
                                                        <option value="GESTION DE LIBERACION">Gestion De Liberacion</option>
                                                        <option value="PRELIQUIDACION">Preliquidacion</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div class="col-md-4 col-sm-4 col-lg-4">
                                                <div class="form-group">
                                                    <label for="LeadName">Vigencia Inicio</label>
                                                    <input type="date" class="form-control" v-model="seguimiento.fecha_inicio" >

                                                </div>
                                            </div>

                                            <div class="col-md-4 col-sm-4 col-lg-4">
                                                <div class="form-group">
                                                    <label for="LeadName">Vigencia Fin</label>
                                                    <input type="date" class="form-control" v-model="seguimiento.fecha_fin" >

                                                </div>
                                            </div>

                                            <div class="col-md-12 col-sm-12 col-lg-12">
                                                <div class="form-group">
                                                    <label for="LeadName">Archivo</label>

                                                    <input  type="file" @change="obtenerfile" name="img_file" id="img_file" accept=".doc,.docx,application/msword,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/pdf, text/plain" >

                                                </div>
                                            </div>

                                            <div class="col-md-12">
                                                <div class="form-group">
                                                    <label>Comentario</label>

                                                    <el-input
                                                        type="textarea"
                                                        placeholder="Comentario"
                                                        v-model="seguimiento.comentario"
                                                        maxlength="255"
                                                        :autosize="{ minRows: 1.3, maxRows: 4}"
                                                        clearable
                                                        show-word-limit
                                                        >
                                                    </el-input>
                                            </div>
                                            </div>
                                            <div class="col-md-12 col-sm-12 col-lg-12">
                                                <button type="button" class="btn btn-success" @click="setRegistrarSeguimiento()">Registrar Seguimiento</button>
                                            </div>

                                    </div>
                                </div>

                            </div>

                        </div>

                        <div class="modal-footer justify-content-between">
                                <label style="float: left;" for="" class="float-left"> </label>
                                <div>
                                <button type="button" class="btn btn-sm btn-secondary" @click="cerrarModalSeguimiento">Cerrar</button>
                                </div>
                        </div>

                    </div><!-- /.modal-content -->
            </div><!-- /.modal-dialog -->
        </div>
    </div>
</template>

<script>
import {alertasM} from '../../util.js';
export default {
    props: ['ruta','usuario'],
    data() {
        return {
            conteo :0,
            arrayNotificacion: [],
            //Seguimiento
            modalShowSeguimiento: false,
            arraySeguimiento: [],
            seguimiento:{
                id: 0,
                estado: 0,
                fecha_inicio: '',
                fecha_fin: '',
                comentario: '',
                file: '',
            },
            form: new FormData,
             mostrarModal: {
                display: 'block',
                background: '#0000006b'
            },
            ocultarModal: {
                display: 'none'
            },
            cotizacion: {}
            //id: JSON.parse(localStorage.getItem('authUser'))['id'],
        }
    },
    mixins: [alertasM],
    methods: {

        logout(){
                this.openCargando();//Activamos ventana de carga de bloqueo
                var url = '/authenticate/logout'
                axios.post(url).then(response => {

                    if (response.data.code == 204) {
                        this.$router.push({name: 'login'})
                        location.reload();
                        localStorage.clear();
                        this.openCargando(true);
                    }
                }).catch(error => {
                    if (error.response.status == 401) {
                        this.$router.push({name: 'login'})
                        location.reload();
                        localStorage.clear();
                        this.openCargando(true);
                    }
                })
        },

        notificar(){
            var url = '/notificar/user';
            let me = this;
            var audio = new Audio('sonido/sonido.mp3');

            axios.post(url)
            .then(res => {

                var respuesta = res.data;
                me.arrayNotificacion = respuesta.notificacion_sistema;
                me.conteo = respuesta.count;
                if(me.conteo > 0){
                    audio.play();
                }
            })
            .catch(error => {
                if (error.response.status == 401) {
                        this.$router.push({name: 'login'})
                        location.reload();
                        localStorage.clear();
                    }
            })
        },

        guardarid(id){
           this.$router.push({name:'cotizacionn',params:{id:id}});
        },

        reproducir(){
            if(this.conteo > 0){
                var audio = new Audio('sonido/sonido.mp3');
                audio.play();
            }
        },

        cerrarModalSeguimiento(){

           this.modalShowSeguimiento = false;
           this.seguimiento.id= 0;
           this.cleanSeguimiento();
           this.arraySeguimiento=[];
        },

        seguimientoDetalle(id){
            let me = this;
            var url = '/cotizacion/seguimiento';
            me.openCargando();
            this.evidencias();
            axios.post(url,{'id': id})
            .then(res => {

                var respuesta = res.data;

                me.arraySeguimiento = respuesta.seguimiento;
                me.cotizacion       = respuesta.detalle;
                me.seguimiento.id = id;
                me.modalShowSeguimiento = true;
                me.openCargando(true);


            })
            .catch(err => {
                me.openCargando(true);
                console.error(err);
                if(err.response.status == 401) {
                    if (localStorage['authUser']) {
                        me.$router.push({name: 'login'})
                        location.reload();
                        localStorage.clear();
                       me.openCargando(true);//Desactivamos ventana de carga de bloqueo
                       }
                }
            })
        },

        cleanSeguimiento(){
            //this.seguimiento.id= 0;
            this.seguimiento.estado= 0;
            this.seguimiento.fecha_inicio= '';
            this.seguimiento.fecha_fin= '';
            this.seguimiento.comentario= '';
            this.seguimiento.file= '';
            this.cotizacion = {};
            this.form = new FormData;
            //$('#file_notifi').fileinput('reset');
            $('#file_notifi').fileinput('clear');
        },

        setRegistrarSeguimiento(){

            //this.openCargando();//Activamos ventana de carga de bloqueo
            let me = this;
            var url = '/seguimiento/registrar';
            me.openCargando();

            me.form.append('id', me.seguimiento.id);
            me.form.append('estado', me.seguimiento.estado);
            me.form.append('fecha_inicio', me.seguimiento.fecha_inicio);
            me.form.append('fecha_fin', me.seguimiento.fecha_fin);
            me.form.append('comentario', me.seguimiento.comentario);
            me.form.append('file', me.seguimiento.file);

            const config = { headers: { 'Content-Type': 'multipart/form-data'}}

            axios.post(url,me.form,config).then(res => {
                me.openCargando(true);

                 if(res.data.status){

                    this.notify(" Registro exitoso","","top","center","fas fa-check-circle","success",' flipInX','flipOutX')
                    me.cerrarModalSeguimiento();
                    me.getListCotizaciones(this.pagination.current_page,this.pag_mostrar);;


                }

            })
            .catch(err => {
                me.openCargando(true);//Desactivamos ventana de carga de bloqueo

               for(var key in err.response.data.errors){

                me.notify(" " + err.response.data.errors[key],"","top","right","fas fa-exclamation-triangle","danger",'animated flipInX','flipOutX')
                    //console.error(err);
               }
               if (err.response.status == 401) {
                        me.$router.push({name: 'login'})
                        location.reload();
                        localStorage.clear();
                       me.openCargando(true);//Desactivamos ventana de carga de bloqueo
                }
                console.error(err);

            })
        },

        evidencias(){
            this.$nextTick(()=>{

                    $('#file_notifi').fileinput({
                                language: 'es',
                                allowedFileExtensions:['jpeg','jpg','png','doc','docx','txt','xls','pdf','xlsx'],
                                maxFileSize: 30000,//8mb
                                showUpload:false,
                                showClose: false,
                                dropZoneEnabled: true,
                                browseLabel: '',
                                removeLabel: '',
                                browseIcon: '<i class="fas fa-folder-open"></i>',
                                removeIcon: '<i class="fas fa-trash-alt"></i>',
                                overwriteInitial: true,showCaption: false,

                                theme: "fas",
                                preferIconicPreview: true,
                                previewFileIconSettings: { // configure your icon file extensions
                                    'doc': '<i class="fas fa-file-word text-primary"></i>',
                                    'xls': '<i class="fas fa-file-excel text-success"></i>',
                                    'ppt': '<i class="fas fa-file-powerpoint text-danger"></i>',
                                    'pdf': '<i class="fas fa-file-pdf text-danger"></i>',
                                    'zip': '<i class="fas fa-file-archive text-muted"></i>',
                                    'htm': '<i class="fas fa-file-code text-info"></i>',
                                    'txt': '<i class="fas fa-file-alt text-info"></i>',
                                    'mov': '<i class="fas fa-file-video text-warning"></i>',
                                    'mp3': '<i class="fas fa-file-audio text-warning"></i>',
                                    // note for these file types below no extension determination logic
                                    // has been configured (the keys itself will be used as extensions)
                                    'jpg': '<i class="fas fa-file-image text-danger"></i>',
                                    'gif': '<i class="fas fa-file-image text-muted"></i>',
                                    'png': '<i class="fas fa-file-image text-primary"></i>'
                                },
                                previewFileExtSettings: { // configure the logic for determining icon file extensions
                                    'doc': function(ext) {
                                        return ext.match(/(doc|docx)$/i);
                                    },
                                    'xls': function(ext) {
                                        return ext.match(/(xls|xlsx)$/i);
                                    },
                                    'ppt': function(ext) {
                                        return ext.match(/(ppt|pptx)$/i);
                                    },
                                    'zip': function(ext) {
                                        return ext.match(/(zip|rar|tar|gzip|gz|7z)$/i);
                                    },
                                    'htm': function(ext) {
                                        return ext.match(/(htm|html)$/i);
                                    },
                                    'txt': function(ext) {
                                        return ext.match(/(txt|ini|csv|java|php|js|css)$/i);
                                    },
                                    'mov': function(ext) {
                                        return ext.match(/(avi|mpg|mkv|mov|mp4|3gp|webm|wmv)$/i);
                                    },
                                    'mp3': function(ext) {
                                        return ext.match(/(mp3|wav)$/i);
                                    }
                                }
                            });

            });
        },
        obtenerfile(e){
                let file =  e.target.files[0]
                this.seguimiento.file = file
        },
        formatoFechaSeguimiento(fecha, formato='D [de] MMMM [del]  YYYY h:mm:ss a'){
            return  moment(fecha).format(formato)
        }

    },
    mounted(){
        setInterval(this.reproducir, 240000);
        this.notificar();

        window.Echo.channel('notificacion-cotizacion')
        .listen('NotificacionesChangedEvent', (user)=>{
            if(user.user['id'] == JSON.parse(localStorage.getItem('authUser'))['id'] || this.usuario.rol[0].name == 'Administrador'){
                this.notificar();
            }

        });
    }
}
</script>

<style>

</style>
